"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalSource = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importDefault(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var constants_1 = require("../../constants");

var modal_punk_1 = require("../modal-punk");

var json = __importStar(require("./localization.json"));

var ModalSource = function ModalSource(_a) {
  var item = _a.item,
      isModalOpen = _a.isModalOpen,
      setModalOpen = _a.setModalOpen,
      language = _a.language,
      theme = _a.theme;
  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage(language);
  var title = "".concat(localizedStrings.modalNews.modalTitle, ": ").concat(item.id);
  var textLink = "".concat(localizedStrings.modalNews.textLink, ":");
  var textCount = "".concat(localizedStrings.modalNews.textCount, ":");
  var textSource = "".concat(localizedStrings.modalNews.textSource, ":");
  var sourceLink = "/sourceId/".concat(item.sourceId);
  var sourceName = (0, basic_frontend_common_1.isMobileView)(constants_1.TABLET_VIEW_WIDTH) ? (0, basic_frontend_common_1.truncateText)(item.sourceName, 24) : item.sourceName;
  return react_1["default"].createElement(modal_punk_1.ModalPunk, {
    title: title,
    isModalOpen: isModalOpen,
    setModalOpen: setModalOpen,
    theme: theme
  }, react_1["default"].createElement(basic_frontend_common_1.TitleSub, {
    marginBottom: true
  }, item.sourceName), react_1["default"].createElement("div", {
    className: "flex flex-row justify-between mb-2"
  }, react_1["default"].createElement(basic_frontend_common_1.TextRegular, null, textLink), react_1["default"].createElement(basic_frontend_common_1.ButtonRegular, {
    text: localizedStrings.modalNews.textClickMe,
    onClick: function onClick() {
      return (0, basic_frontend_common_1.openUrl)(sourceLink);
    },
    type: basic_frontend_common_1.ButtonType.secondary,
    size: basic_frontend_common_1.ButtonSize.small
  })), react_1["default"].createElement("div", {
    className: "flex flex-row justify-between mb-2"
  }, react_1["default"].createElement(basic_frontend_common_1.TextRegular, null, textCount), react_1["default"].createElement(basic_frontend_common_1.TextRegular, null, item.sourceCount)), react_1["default"].createElement("div", {
    className: "flex flex-row justify-between mb-2"
  }, react_1["default"].createElement(basic_frontend_common_1.TextRegular, null, textSource), " ", react_1["default"].createElement(basic_frontend_common_1.TextRegular, null, sourceName)), react_1["default"].createElement("div", {
    className: "text-center ml-4 mr-4 mt-8 mb-10"
  }, react_1["default"].createElement(basic_frontend_common_1.ButtonRegular, {
    text: localizedStrings.modalNews.buttonCloseText,
    onClick: function onClick() {
      return setModalOpen;
    },
    type: basic_frontend_common_1.ButtonType.primary,
    size: basic_frontend_common_1.ButtonSize.small
  })));
};

exports.ModalSource = ModalSource;